import { render, staticRenderFns } from "./DashboardAppPage.vue?vue&type=template&id=17f2cab3&scoped=true&"
import script from "./DashboardAppPage.vue?vue&type=script&lang=js&"
export * from "./DashboardAppPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2cab3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f2cab3')) {
      api.createRecord('17f2cab3', component.options)
    } else {
      api.reload('17f2cab3', component.options)
    }
    module.hot.accept("./DashboardAppPage.vue?vue&type=template&id=17f2cab3&scoped=true&", function () {
      api.rerender('17f2cab3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/DashboardAppPage.vue"
export default component.exports